<template>
  <div>
    <div class="header clearfix">
      <div class="header_left fl">
        <router-link tag="div" to="/" class="pic" v-if="seotitle.logo_url">
          <img :src="seotitle.logo_url" alt srcset />
        </router-link>

        <ul>
          <router-link tag="li" to="/classlistarr">课程</router-link>
          <router-link tag="li" :to="{path:'/classlistarr',query:{typeindex:2}}">直播课程</router-link>
          <router-link tag="li" to="/teacherlist">名师专区</router-link>
          <router-link tag="li" to="/arealist">机构专区</router-link>
          <!-- <li>商城</li> -->
        </ul>
      </div>
      <div class="header_right fr">
        <!--<el-dropdown class="fl">-->
          <!--<div class="down">下载app</div>-->
          <!--<el-dropdown-menu class="appcode" slot="dropdown">-->
            <!--<div class="title">{{seotitle.seo_title}} - 随时随地学习知识</div>-->
            <!--<div class="coder clearfix">-->
              <!--<div class="pics" v-if="code == null"></div>-->
              <!--<div class="pics" v-else>-->
                <!--<Qrcode :msg="code " class="code_img"></Qrcode>-->
              <!--</div>-->
              <!--<div class="infos">-->
                <!--<div class="btns on" @mouseover="changeActive(0)" @mouseout="removeActive()">-->
                  <!--<i class="iconfont icon-ios"></i>-->
                  <!--App Store下载-->
                <!--</div>-->
                <!--<div class="btns" @mouseover="changeActive(1)" @mouseout="removeActive()">-->
                  <!--<i class="iconfont icon-anzhuo"></i>-->
                  <!--Android下载-->
                <!--</div>-->
                <!--<p>扫描下载{{seotitle.seo_title}}</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</el-dropdown-menu>-->
        <!--</el-dropdown>-->
        <div class="search fl">
          <el-dropdown @visible-change="visiblechange">
            <el-input v-model="input" placeholder="请输入关键字..." class="input fl"></el-input>
            <el-tag type="info" class="fl" v-if="keylist[0] != undefined">
              <router-link
                tag="i"
                :to="{path:'/search',query:{keywords:keylist[0].keyword}}"
              >{{keylist[0].keyword}}</router-link>
            </el-tag>
            <el-tag type="info" class="fl" v-if="keylist[1] != undefined">
              <router-link
                tag="i"
                :to="{path:'/search',query:{keywords:keylist[1].keyword}}"
              >{{keylist[1].keyword}}</router-link>
            </el-tag>
            <el-button icon="el-icon-search" type="primary" round @click="searchbosx"></el-button>
            <el-dropdown-menu slot="dropdown" class="searchos" id="seararrs">
              <div class="hottitle">热搜</div>
              <div class="ps clearfix">
                <router-link
                  tag="div"
                  :to="{path:'/search',query:{keywords:item.keyword}}"
                  class="no"
                  v-for="(item,index) in keylist"
                  :key="index"
                >{{item.keyword}}</router-link>
              </div>
              <div v-if=" locallist.length != 0 " style="position: relative;" class="lishi">
                <i class="el-icon-delete" @click="lishi"></i>
                <router-link
                  tag="p"
                  :to="{path:'/search',query:{keywords:item}}"
                  v-for="(item,index) in locallist"
                  :key="index"
                >{{item}}</router-link>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <router-link tag="div" to="/course" class="myclass fl" v-if="isLogin">我的课程</router-link>
        <div class="headerimg fl" v-if="isLogin">
          <el-dropdown>
            <el-avatar :size="32" :src="userinfo.avatar"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="clearfix ge">
                <div class="pic">
                  <img :src="userinfo.avatar" alt srcset />
                </div>
                <div class="xin">
                  <h3>{{userinfo.nick}}</h3>
                  <p>{{userinfo.phone}}</p>
                  <div class="spanboxs">
                    <span>课程 {{userinfo.myVideo}}</span>
                    <span>关注 {{userinfo.videoCollection + userinfo.teacherCollection}}</span>
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="spancontant clearfix">
                  <router-link tag="span" to="/course">
                    <i class="iconfont icon-wodekecheng"></i>
                    我的课程
                  </router-link>
                  <router-link tag="span" to="/orderview">
                    <i class="iconfont icon-dingdan"></i>
                    订单中心
                  </router-link>
                  <router-link tag="span" to="/follow">
                    <i class="iconfont icon-wodeguanzhu"></i>
                    我的关注
                  </router-link>
                  <span>
                    <i class="iconfont icon-kaoshi"></i>
                    我的考试
                  </span>
                  <router-link tag="span" to="/settings">
                    <i class="iconfont icon-gerenshezhi1"></i>
                    个人设置
                  </router-link>
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="safeexit" @click="logout">安全退出</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="spanbox fl" v-else>
          <router-link tag="span" to="/logins">登录</router-link>/
          <router-link tag="span" to="/register">注册</router-link>
        </div>
      </div>
    </div>
    <div style="height:74px"></div>
  </div>
</template>

<script>
import {
  Input,
  Tag,
  Button,
  Avatar,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message
} from "element-ui";
import headers from "@/components/header.vue";
import utilFile from "@/ace/ace.js";
import Qrcode from "@/components/Qrcode.vue";
export default {
  components: {
    Qrcode,
    [Input.name]: Input,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Avatar.name]: Avatar,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Message.name]: Message
  },
  data() {
    return {
      input: "",
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      name: 0,
      keylist: [],
      locallist: [], //搜索历史
      userinfo: {}, //登录信息
      isLogin: false,
      seotitle: {},
      code: null
    };
  },
  inject: ['reload'],
  methods: {
    visiblechange(dowm) {
      if (dowm) {
        //this.hotsearch();
        if (localStorage.locallist) {
          var arr = localStorage.locallist.split(",");
          this.locallist = arr;
        }
      }
    },
    searchbosx() {
      this.$router.push({
        path: "/search",
        query: {
          keywords: this.input
        }
      });
      this.reload();
    },
    hotsearch() {
      this.$axios({
        method: "post",
        url: `/api/home.getSearchConfig`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.keylist = totaldata;
      });
    },
    lishi() {
      localStorage.removeItem("locallist");
      this.locallist = [];
    },
    user() {
      this.$axios({
        method: "post",
        url: `/api/user.infomation`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.isLogin = false;
        } else {
          let userinfo = JSON.parse(utilFile.decrypt(res.data.data));
          this.userinfo = userinfo;
          this.isLogin = true;
        }
      });
    },
    logout() {
      this.$axios({
        method: "post",
        url: `/api/authority.logout`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 200) {
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          this.isLogin = false;
          this.$router.go();
        }
      });
    },
    titlefunc() {
      this.$axios({
        method: "post",
        url: `/api/home.config`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let data = JSON.parse(utilFile.decrypt(res.data.data));
        this.seotitle = data;
      });
    },
    changeActive(index) {
      if (index == 0) {
        this.code = this.seotitle.ios_down_url;
      } else {
        this.code = this.seotitle.android_down_url;
      }
    },
    removeActive() {
      this.code = null;
    }
  },
  mounted() {
    this.hotsearch();
    if (localStorage.locallist) {
      var arr = localStorage.locallist.split(",");
      this.locallist = arr;
    }
    this.user();
    this.titlefunc();
  }
};
</script>

<style scoped>
.header {
  box-sizing: border-box;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding-left: 54px;
  padding-right: 28px;
  cursor: pointer;
  z-index: 1000;
  background-color: #fff;
}

.header .pic {
  display: inline-block;
  vertical-align: middle;
  line-height: 74px;
  font-size: 0;
  float: left;
}

.header .pic img {
  display: inline-block;
  vertical-align: middle;
}

.header ul {
  float: left;
  margin-left: 30px;
}

.header ul li {
  float: left;
  font-size: 15px;
  line-height: 74px;
  color: #626262;
  padding: 0 28px;
  cursor: pointer;
}

.header .search {
  background-color: #f1f1f1;
  border-radius: 50px;
  overflow: hidden;
  margin-top: 15px;
  cursor: pointer;
}
.header .down {
  line-height: 74px;
  font-size: 15px;
  color: #626262;
  margin-right: 19px;
}
.header .input {
  width: 150px;
  height: 42px;
}
.header .myclass {
  font-size: 15px;
  color: #626262;
  line-height: 74px;
  margin-left: 10px;
  margin-right: 26px;
}
.header .headerimg {
  margin-top: 20px;
  cursor: pointer;
}

.safeexit {
  text-align: right;
  font-size: 12px;
  color: #414141;
}

.spanbox {
  line-height: 74px;
  font-size: 14px;
  color: #b2bfc3;
  margin-left: 10px;
  cursor: pointer;
}
</style>
<style>
@media screen and (max-width: 1366px) {
  .header ul li {
    padding: 0 14px !important;
  }
}
.header .el-input__inner {
  background-color: transparent;
  border: 0;
}
.header .el-tag {
  height: 24px;
  line-height: 24px;
}
.header .el-tag.el-tag--info {
  background-color: #fff;
  font-size: 13px;
  color: #6e7d78;
  margin-left: 8px;
  margin-top: 9px;
}
.header .el-button.is-round {
  padding: 12px 17px;
  margin-left: 13px;
}

.el-dropdown-menu {
  width: 303px;
  padding-top: 33px;
  border-radius: 10px;
  right: 0;
  left: auto;
}

.el-dropdown-menu .ge {
  margin-bottom: 16px;
}
.el-dropdown-menu .pic {
  float: left;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 17px;
}

.el-dropdown-menu .pic img {
  height: 100%;
  width: 100%;
}

.el-dropdown-menu .xin {
  float: left;
}

.el-dropdown-menu .xin h3 {
  font-size: 16px;
  color: #414141;
  margin-bottom: 7px;
}

.el-dropdown-menu .xin p {
  font-size: 14px;
  color: #414141;
  margin-bottom: 11px;
  cursor: pointer;
}

.el-dropdown-menu .xin .spanboxs {
  line-height: 1em;
}

.el-dropdown-menu .xin .spanboxs span {
  font-size: 12px;
  color: #a19ba2;
  margin-right: 13px;
  line-height: 1em;
}

.el-dropdown-menu .spancontant span {
  width: 49%;
  float: left;
  font-size: 14px;
  color: #1c1f21;
  line-height: 36px;
  background-color: #f8fafc;
  border-radius: 3px;
  text-align: center;
  margin-bottom: 3px;
  margin-right: 2%;
}

.el-dropdown-menu .spancontant span:nth-last-of-type(2n) {
  margin-right: 0;
}

.el-dropdown-menu .spancontant span i {
  font-size: 14px;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #fff;
}

.el-dropdown-menu .spancontant span:hover {
  background-color: #d9dde1;
}

.appcode {
  padding: 25px;
  box-sizing: border-box;
}

.appcode .title {
  text-align: center;
  font-size: 14px;
  color: #414141;
  margin-bottom: 20px;
}

.appcode .pics {
  width: 110px;
  height: 110px;
  overflow: hidden;
  float: left;
  display: block;
}

.appcode .infos {
  float: right;
  cursor: pointer;
  text-align: center;
}

.appcode .infos .btns {
  width: 133px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  margin-bottom: 9px;
  background-color: #4d555d;
  border-radius: 50px;
  position: relative;
}

.appcode .infos .btns:hover .pics {
  display: block;
}

.appcode .infos .btns.on {
  background-color: #4099ff;
}

.searchos {
  padding-top: 0;
  cursor: pointer;
}

.searchos .hottitle {
  font-size: 12px;
  color: #414141;
  margin-top: 12px;
  margin-bottom: 8px;
  box-sizing: border-box;
  padding-left: 12px;
}

.searchos .ps {
  box-sizing: border-box;
  padding-left: 12px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 12px;
}

.searchos .ps .no {
  font-size: 12px;
  color: #414141;
  line-height: 24px;
  padding: 0 14px;
  color: #414141;
  float: left;
  margin-right: 5px;
  background-color: #eeeeef;
  border-radius: 50px;
  margin-bottom: 7px;
}

.searchos p {
  font-size: 12px;
  color: #414141;
  margin-bottom: 23px;
  box-sizing: border-box;
  padding-left: 12px;
}

.seararrs {
  cursor: pointer;
}

.lishi{
  height: 106px;
  overflow-y: auto;
}

.lishi i {
  font-size: 16px;
  right: 6px;
  top: 0;
  position: absolute;
  color: #000000;
}

.lishi::-webkit-scrollbar {
	width: 10px; 
	height: 1px; 
}

.lishi::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(56, 160, 255, 0.2);
  box-shadow: inset 0 0 5px rgba(56, 160, 255, 0.2);
	background: #409EFF;
}

.lishi::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 5px rgba(56, 160, 255, 0.2);
  box-shadow: inset 0 0 5px rgba(56, 160, 255, 0.2);
	border-radius: 10px;
	background: #EDEDED;
}

</style>